export default __webpack_public_path__ + "static/media/SCBT.82f3cf59.png";